/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Incident } from './Incident';
import {
    IncidentFromJSON,
    IncidentFromJSONTyped,
    IncidentToJSON,
} from './Incident';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { PayloadTypeConstants } from './PayloadTypeConstants';
import {
    PayloadTypeConstantsFromJSON,
    PayloadTypeConstantsFromJSONTyped,
    PayloadTypeConstantsToJSON,
} from './PayloadTypeConstants';

/**
 * 
 * @export
 * @interface IncidentResponse
 */
export interface IncidentResponse {
    /**
     * 
     * @type {PayloadTypeConstants}
     * @memberof IncidentResponse
     */
    type: PayloadTypeConstants;
    /**
     * 
     * @type {Array<Message>}
     * @memberof IncidentResponse
     */
    messages: Array<Message>;
    /**
     * 
     * @type {Incident}
     * @memberof IncidentResponse
     */
    payload?: Incident;
}

/**
 * Check if a given object implements the IncidentResponse interface.
 */
export function instanceOfIncidentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function IncidentResponseFromJSON(json: any): IncidentResponse {
    return IncidentResponseFromJSONTyped(json, false);
}

export function IncidentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PayloadTypeConstantsFromJSON(json['type']),
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : IncidentFromJSON(json['payload']),
    };
}

export function IncidentResponseToJSON(value?: IncidentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PayloadTypeConstantsToJSON(value.type),
        'messages': ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': IncidentToJSON(value.payload),
    };
}

